import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';
import { DatetimePicker, Picker, Switch } from 'mint-ui';
import 'mint-ui/lib/style.css';
import App from './components/App';
import router from './router';
import store from './store';
import sdk from './global/sdk';
import config from './global/config';
import vueTap from 'v-tap';
import _gDic from './global/globalDic';
import falseNewsDic from './global/falseNewsDic';
import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
import extend from './utils/extend';
import hex_md5 from './utils/md5';
import platform from './utils/platform';
import util from './utils/util';
import bindRtcEvents from './extra/BindRtcEvents';
import { isNeedConvert } from './global/richTextFormat';
import customStyle from './global/customStyle';
const isEmpty = util.isEmpty;
const isEmptyObject = util.isEmptyObject;
const strToNumCompare = util.strToNumCompare;
const sumBigNumber = util.sumBigNumber;
let Monitor = require('fe-monitor');
const saveExistFalseMsgs = falseNewsDic.saveExistFalseMsgs;

let sessionChangeBeginMarker = 0;
let sessionChangeDoneMarker = 0;

require('./assets/style/style.less');

(function (doc, win) {
  let docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  let recalc = function () {
    let width = docEl.clientWidth;
    if (width < 375) {
      width = 375;
    }
    let _htmlFontSize = width / 12;
    _gDic.set('htmlFontSize', _htmlFontSize);
    docEl.style.fontSize = _htmlFontSize + 'px';
  };
  recalc();
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
})(document, window);

(function (doc) {
  let _canvas = doc.createElement("canvas");
  let isSupportedCanvas = _canvas.getContext('2d');
  _gDic.set('isSupportedCanvas', !!isSupportedCanvas);
  _canvas = null;
})(document);
/* (function (document) {
  var hidden, state, visibilityChange;
  if (typeof document.hidden !== "undefined") {
    hidden = "hidden";
    visibilityChange = "visibilitychange";
    state = "visibilityState";
  } else if (typeof document.mozHidden !== "undefined") {
    hidden = "mozHidden";
    visibilityChange = "mozvisibilitychange";
    state = "mozVisibilityState";
  } else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
    state = "msVisibilityState";
  } else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
    state = "webkitVisibilityState";
  }

  if (document[state] != undefined) {
    document[state] == 'visible';
  }

  // 添加监听器，在title里显示状态变化
  console.log('addEventListener 1', document[state]);
  if (document.addEventListener) {
    console.log('addEventListener 2', visibilityChange);
    document.addEventListener(visibilityChange, function () {
      console.log('document[state]', document[state]);
      console.log('isMain', sdk.get().isMain());
      if (document[state] == 'visible' && !sdk.get().isMain()) {
        sdk.get().connect();
      }
    }, false);
  }
})(document); */


(function (window) {
  let vm;
  let WapIMApp = function (options) {
    const APP_SELF = this;
    let defaults = {
      sdk: null,
      config: {}
    };
    Object.assign(defaults, options);
    sdk.set(defaults.sdk);
    config.set(defaults.config);
    if (defaults.sdk && defaults.sdk.options && !isEmpty(defaults.sdk.options.is_show_audio_video)) {
      config.set({
        is_show_audio_video: defaults.sdk.options.is_show_audio_video
      });
    } else {
      config.set({
        is_show_audio_video: defaults.sdk && defaults.sdk.options && defaults.sdk.options.supported_functions && defaults.sdk.options.supported_functions.is_show_audio_video
      });
    }
    config.set({
      is_support_provide_contactinfo: defaults.sdk && defaults.sdk.options && defaults.sdk.options.supported_functions && defaults.sdk.options.supported_functions.is_support_provide_contactinfo
    });
    let global_css_configs = options.config.global_css_configs;
    if (!isEmptyObject(global_css_configs)) {
      global_css_configs = { ...customStyle, ...global_css_configs }
    } else {
      global_css_configs = { ...customStyle }
    }
    config.set({ 'global_css_configs': global_css_configs });
    if (!sdk.get().isLogined()) {
      sdk.get().start();
    }


    Vue.use(Vuex);
    Vue.use(vueTap);
    Vue.use(Toast, {
      type: 'center',
      duration: 1000
    });
    Vue.component(DatetimePicker.name, DatetimePicker);
    Vue.component(Picker.name, Picker);
    Vue.component(Switch.name, Switch);
    class VueTouch {
      /**
       * @param el 绑定的DOM
       * @param binding 自定义指令中的binding对象
       * @param type 绑定的事件类型
       */
      constructor(el, binding, type) {

        let g = this;

        g.obj = el;
        g.binding = binding;
        g.touchType = type;

        g.firstTouchPosition = { x: 0, y: 0 };
        g.firstTouchTime = 0;

        /**
          * =========================================
          * 事件绑定有两种方式
          * @example
          *  1. v-tap="showDialog" 绑定一个方法对象
          *  2. v-tap="{fn:click123, param1:1, param2:2, param3:{aaa:'123'} ...}"
          *      绑定一个JSON字面量，fn是执行的方法，后边的是需要传递的参数
          * 事件回调参数
          * @param 第一个参数是event，事件对象
          * @param 第二个参数是 binding.value，也就是v-tap=""双引号中的部分（如示例2，第二个参数就是 {fn:click123, param1:1, param2:2, param3:{aaa:'123'} ...}）
          * =========================================
          */
        g.callBack = typeof (binding.value) === "object" ? binding.value.fn : binding.value;

        // 事件监听回调集合
        let _listener = Object.create(null);

        // 事件方法
        let _listen = (type) => {
          return function (e) {

            /**
             * 取出修饰符（和v-on的一样）
             */
            let { stop, prevent, self, once } = g.binding.modifiers;

            // 配置判断
            if (stop) e.stopPropagation();
            if (prevent) e.preventDefault();
            if (once) g.obj.removeEventListener("touch" + type, _listener[type]);
            if (self && e.target !== e.currentTarget) return;

            g[type](e);
          }
        };

        _listener.start = _listen('start');
        _listener.end = _listen('end');
        _listener.move = _listen('move');

        // 事件绑定
        this.obj.addEventListener("touchstart", _listener.start, false);
        this.obj.addEventListener("touchend", _listener.end, false);
        this.obj.addEventListener("touchmove", _listener.move, false);
      }

      // 点击开始
      start(e) {

        let g = this;

        // @update 2018.3.26 这里做了一个修改
        g.moved = false; //是否移动了
        g.leaved = false; //是否离开了
        g.longTouched = false; //是否执行了长按操作

        // 获取开始点击位置和时间
        g.firstTouchPosition = g.getMultiCenter(e.changedTouches);
        g.firstTouchTime = e.timeStamp;

        // 判断长按操作 @TODO 稍微有点触发时机上的问题，待修正
        g.time = setTimeout(function () {
          if (!g.leaved && !g.moved) {
            g.touchType === "longtap" && g.callBack(e, g.binding.value);
            g.longTouched = true;
          }
        }.bind(g), 1000);
      }

      // 点击结束
      end(e) {

        let g = this;

        // 点击结束获取点击位置并计算位移和时差
        let { x, y } = g.getMultiCenter(e.changedTouches);
        let _disX = x - g.firstTouchPosition.x;
        let _disY = y - g.firstTouchPosition.y;
        let _dis = Math.sqrt(_disX * _disX + _disY * _disY);
        let _timeDis = e.timeStamp - g.firstTouchTime;

        clearTimeout(g.time);

        // 计算滑动角度
        let _angle = this.getAngle(_disX, _disY);

        // 判断滑动方向
        if (_dis > 18 && _timeDis < 300) {
          g.touchType === "swipe" && g.callBack(e, g.binding.value);
          if (_angle >= 60 && _angle <= 120)
            g.touchType === "swipedown" && g.callBack(e, g.binding.value);
          if (_angle <= -60 && _angle >= -120)
            g.touchType === "swipeup" && g.callBack(e, g.binding.value);
          if (_angle <= 20 && _angle >= -20)
            g.touchType === "swipeleft" && g.callBack(e, g.binding.value);
          if ((_angle <= -160 && _angle > -180) || (_angle >= 160 && _angle <= 180))
            g.touchType === "swiperight" && g.callBack(e, g.binding.value);
        } else {
          if (!g.longTouched && !g.moved) {
            g.touchType === "tap" && g.callBack(e, g.binding.value);
            g.leaved = true;
          }
        }
      }

      move() {
        this.moved = true;
      }

      /**
       * 获取点击集合的中心坐标
       * @param touches touch对象集合
       * @return {{x: number, y: number}}
       */
      getMultiCenter(touches) {

        let g = this, x = 0, y = 0;

        const _length = touches.length;

        for (let i = 0; i < _length; i++) {
          x += touches[i].pageX;
          y += touches[i].pageY;
        }

        return {
          x: Math.round(x / _length),
          y: Math.round(y / _length)
        };
      };

      /**
       * 获取滑动的角度
       * @param disX X轴的位移
       * @param disY Y轴的位移
       * @return 角度
       */
      getAngle(disX, disY) {
        let g = this;

        if (typeof disX !== 'number' || typeof disY !== 'number')
          return 45;

        return Math.atan2(disY, disX) * 180 / Math.PI;
      }
    }

    Vue.directive("tap", {
      bind: function (el, binding) {
        new VueTouch(el, binding, "tap");
      }
    });
    Vue.directive("swipe", {
      bind: function (el, binding) {
        new VueTouch(el, binding, "swipe");
      }
    });
    Vue.directive("swipeleft", {
      bind: function (el, binding) {
        new VueTouch(el, binding, "swipeleft");
      }
    });
    Vue.directive("swiperight", {
      bind: function (el, binding) {
        new VueTouch(el, binding, "swiperight");
      }
    });
    Vue.directive("swipedown", {
      bind: function (el, binding) {
        new VueTouch(el, binding, "swipedown");
      }
    });
    Vue.directive("swipeup", {
      bind: function (el, binding) {
        new VueTouch(el, binding, "swipeup");
      }
    });
    Vue.directive("longtap", {
      bind: function (el, binding) {
        new VueTouch(el, binding, "longtap");
      }
    });

    Vue.config.errorHandler = function (err, vm, info) {
      //throw('new Error'+err+info);
      setTimeout(() => {
        throw new Error(err)
      }, 0)
    }

    // 禁止safari双击放大问题
    let ver = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/) || {};

    if (platform.isSafari && ['10', '11'].indexOf(ver[1]) !== -1) {
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      })
      let lastTouchEnd = 0;
      document.addEventListener('touchend', function (event) {
        var now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false)
    }


    // vm = new Vue({
    //   el: '#app',
    //   store,
    //   router,
    //   template: '<App/>',
    //   components: {
    //     App
    //   },
    //   mounted() {
    //     APP_SELF.bindRTCEmitter && APP_SELF.bindRTCEmitter.call(defaults);
    //   }
    // });
    vm = new Vue({
      router,
      store,
      mounted() {
        APP_SELF.bindRTCEmitter && APP_SELF.bindRTCEmitter.call(defaults);
      },
      render: h => h(App)
    }).$mount("#app")

    _gDic.set('sysUser', '60687145693708@2');
    _gDic.set('envs', sdk.get().options.envs);
    if (sdk.get().options.envs === 'integrate') {
      _gDic.set('sysUser', '59911917385233@2');
    }

    sdk.get().addEventListener('login', function () {
      let me = sdk.get().me();
      _gDic.set('me', me);
      vm.$store.dispatch('setMe', me);
    });

    sdk.get().addEventListener('contactOnlineStatusChanged', function (data) {
      vm.$store.dispatch('updateOnlineStatus', data);
    });

    // 监听消息接收事件
    sdk.get().addEventListener('msgReceived', function (data) {
      vm.$store.dispatch('receivedMsgs', data);
    });

    // 匿名会话合并事件
    sdk.get().addEventListener('anonymousContactLogined', function (data) {
      let pageName = vm._route.name;
      if (pageName == 'chat' && vm.$store.state && vm.$store.state.chat && vm.$store.state.chat.contact) {
        let contact = vm.$store.state.chat.contact;
        if (!isEmpty(contact) && !isEmpty(data.otherContact) && contact.user_id + '@' + contact.user_source != data.otherContact.user_id + '@' + data.otherContact.user_source) {
          vm.$router.replace({
            name: 'chat',
            params: {
              params: 'user_id=' + data.otherContact.user_id + '&' + 'user_source=' + data.otherContact.user_source
            }
          });
          window.location.reload();
        } else {
          vm.$store.dispatch('getMsgs', vm.$store.state.chat.contact);
        }
      } else if (pageName == 'home' && vm.$store.state && vm.$store.state.home) {
        vm.$store.dispatch('reloadSessions');
      }
    })

    // 页面假消息存储
    sdk.get().addEventListener('falseNews', function (tmpMsgs) {
      let client_msgs = [];
      let me = sdk.get().me();
      for (let msgs_key in tmpMsgs) {
        if (tmpMsgs[msgs_key] && tmpMsgs[msgs_key].length) {
          let sessions_msgs_hash = vm.$store.state.home.sessions_msgs_hash || {};
          let msgs = vm.$store.state.chat.msgs || [];
          let contact = vm.$store.state.chat.contact || {};
          let contactKey = contact.user_id + '@' + contact.user_source;
          let sessions_msgs_hash_last_id = (sessions_msgs_hash[msgs_key] ? sessions_msgs_hash[msgs_key].msg_id : '');
          let sessions_false_last_msg = falseNewsDic.getFalseLastMsg(msgs_key);
          let sessions_false_last_msg_msgId = sessions_false_last_msg ? sessions_false_last_msg.msg_id : '';
          let lastChatMsgId = (contactKey === msgs_key && msgs.length) ? msgs[msgs.length - 1].msg_id : '';
          let lastSessionMsgId = strToNumCompare(sessions_false_last_msg_msgId, sessions_msgs_hash_last_id) > 0 ? sessions_false_last_msg_msgId : sessions_msgs_hash_last_id;
          let lastMsgId = strToNumCompare(lastChatMsgId, lastSessionMsgId) > 0 ? lastChatMsgId : lastSessionMsgId;
          if (!isEmpty(lastMsgId)) {
            let _falseMsgs = [];
            let last_msg_id = lastMsgId;
            tmpMsgs[msgs_key].forEach((msg) => {
              if (!msg.shop_id) {
                msg.follow_msg_id = last_msg_id;
                last_msg_id = sumBigNumber(last_msg_id, '1');
                msg.msg_id = last_msg_id;
                msg.tmpKey = msgs_key;
                if (`${msg.sender_id}` === `${me.user_id}` && `${msg.sender_source}` === `${me.user_source}`) {
                  msg.ismine = true;
                } else {
                  msg.ismine = false;
                }
                _falseMsgs.push(msg);
                saveExistFalseMsgs(msg, msgs_key);
              }
            })
            if (_falseMsgs && _falseMsgs.length) {
              falseNewsDic.setFalseLastMsg(msgs_key, Object.assign({}, _falseMsgs[_falseMsgs.length - 1], {
                msg_id: _falseMsgs[_falseMsgs.length - 1].msg_id
              }))
            }
            vm.$store.dispatch('addFalseMsgs', {
              tmpKey: msgs_key,
              falseMsgs: _falseMsgs,
              last_msg_id: lastMsgId
            });
            vm.$store.dispatch('addFalseLastMsgs', {
              tmpKey: msgs_key,
              falseMsgs: _falseMsgs,
              last_msg_id: lastMsgId
            });
            falseNewsDic.set(_falseMsgs);
            client_msgs = client_msgs.concat(_falseMsgs);
          }
          // let _msgs_key = msgs_key.split('@');
          // sdk.get().getSpecifySessionList({
          //   sessions: [{
          //     other_id: _msgs_key[0],
          //     other_source: Number(_msgs_key[1])
          //   }],
          //   isCacha: true
          // }, (sessions)=>{
          //   console.log(sessions, 'sessions')
          // }, ()=>{

          // })
        }
      }
      sdk.get().reportMessages({
        client_msgs: client_msgs
      });
    });

    // 监听消息替换事件
    sdk.get().addEventListener('replaceMsgReceived', function (data) {
      vm.$store.dispatch('replaceMsgReceived', data);
    });

    sdk.get().addEventListener('unreadChanged', function (unreadamount) {
      vm.$store.dispatch('updateUnread', unreadamount);
      handleSession();
    });

    sdk.get().addEventListener('sessionChanged', function () {
      handleSession();
    });

    let handleSession = function () {
      //var _sessionChangeMarker = sessionChangeBeginMarker++;
      let unread = sdk.get().getAllUnreadAmount();
      let sessions = sdk.get().getAllSessions();
      // 外部sessions处理，如将各别会话置顶
      let me = sdk.get().me();
      let currentKey = me.user_id + '@' + me.user_source;
      config.get('sessions-converter')(sessions, function (sessions) {
        let userkeys = sessions.map(function (session) {
          return {
            'user_id': session.user.user_id,
            'user_source': session.user.user_source
          };
        });
        userkeys.push({
          user_id: me.user_id,
          user_source: me.user_source
        })
        sdk.get().getContact(userkeys, function (contacts) {
          sessions.forEach(function (session) {
            let key = session.user.user_id + '@' + session.user.user_source;
            session.contact = extend(true, contacts[key], session.contact);
            let msg_set = session.contact.msg_set;
            let user = $.extend(true, {}, contacts[key], session.contact, session.user);
            if (!isEmpty(session.user.update_time) && !isEmpty(msg_set)) {
              msg_set.ses_top = !isEmpty(session.user.ses_top) ? session.user.ses_top : !isEmpty(user.msg_set.ses_top) ? user.msg_set.ses_top : null;
              msg_set.silent = !isEmpty(session.user.silent) ? session.user.silent : !isEmpty(user.msg_set.silent) ? user.msg_set.silent : null;
              session.contact.msg_set = msg_set;
              if (!isEmpty(session.user.is_blacked)) {
                session.contact.is_blacked = session.user.is_blacked + '';
              }
            }
            session.unread_show_type = user.msg_set && user.msg_set.silent == 1 ? 'rash' : '';
            session.unread = unread[key];
            if (session && session.msg && (currentKey != session.msg.sender_id + '@' + session.msg.sender_source) && !isEmpty(session.contact.remark) && !isEmpty(session.contact.remark.remark_name)) {
              if (!isEmpty(session.msg.content.operator) && !isEmpty(session.msg.replace) && !isEmpty(session.msg.replace.content) && !isEmpty(session.msg.replace.content._replaceMsg) && !isEmpty(session.msg.content.operator.pos_start) && !isEmpty(session.msg.content.operator.pos_end)) {
                session.msg.content.text = session.msg.content.msg = session.msg.replace.content._replaceMsg.substring(0, session.msg.content.operator.pos_start) + session.contact.remark.remark_name + session.msg.replace.content._replaceMsg.substring(session.msg.content.operator.pos_end);
              } else if (!isEmpty(session.msg.content._operator) && !isEmpty(session.msg.content._replaceMsg) && !isEmpty(session.msg.content._operator) && !isEmpty(session.msg.content._operator.pos_start) && !isEmpty(session.msg.content._operator.pos_end)) {
                session.msg.content.text = session.msg.content.msg = session.msg.content._replaceMsg.substring(0, session.msg.content._operator.pos_start) + session.contact.remark.remark_name + session.msg.content._replaceMsg.substring(session.msg.content._operator.pos_end);
              }
            }
            // 处理免打扰和屏蔽同时存在
            if (session.contact.is_blacked == '1' && session.contact.msg_set.silent == '1') {
              session.contact.is_display = 'none';
            }
          });
          // if (_sessionChangeMarker > sessionChangeDoneMarker) {
          //   sessionChangeDoneMarker = _sessionChangeMarker;
          // }
          //if (_sessionChangeMarker >= sessionChangeDoneMarker) {
          vm.$store.dispatch('updateSessions', sessions);
          //} else {
          //debugger;
          //}
        });
      });
    };

    let meId = options.sdk.options.user_id;

    falseNewsDic.setUser(meId, options.sdk.options.source);

    var md5Key = '61e2e9e0d3e683bdfb96b66f60a07f31';
    var monitor = Monitor.getInstance({
      projectID: 'IM_M',
      userId: meId ? hex_md5(hex_md5(meId) + md5Key) : ''
    });
    monitor.errorReport();
    monitor.performanceReport();
  };
  // 隐藏聊天窗口输入框
  WapIMApp.prototype.disableEditor = function () {
    vm.$store.dispatch('setIsShowEditor', false);
  };
  // 更改头部展示信息
  WapIMApp.prototype.setTopic = function (user_id, user_source, topic) {
    if (!topic) {
      return;
    }
    // 保存用户topic信息
    let key = user_id + '@' + user_source;
    _gDic.set(key, topic);
    let contact = vm.$store.state.chat.contact;

    // 当前打开聊天窗口，并且聊天对象为变更用户时
    if (contact.user_id && contact.user_id + '' === user_id + '' && contact.user_source + '' === user_source + '') {
      vm.$store.dispatch('setTopic', topic);
    }
  };
  WapIMApp.prototype.toast = function (status, txt) {
    vm.$toast.center(txt);
  }
  bindRtcEvents(WapIMApp);
  window.WapIMApp = WapIMApp;
})(window);
